import { render, staticRenderFns } from "./yhIndex.vue?vue&type=template&id=3ec563d8&"
import script from "./yhIndex.vue?vue&type=script&lang=js&"
export * from "./yhIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports